import React from 'react';

import { useIntl } from 'react-intl';

import { MethodType } from './styled';

const CashMethod = () => {
  const { formatMessage } = useIntl();

  return <MethodType>{formatMessage({ id: 'payWithCash' })}</MethodType>;
};

export default CashMethod;
